export default __webpack_public_path__ + "static/media/generic.a96dd1a1.svg";